(function(angular){
	'use strict';
	
	var hypotheticalPerformanceObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			plans: '<',
			selectedGoal: '<?',
			amount: '<?',
			includeCta: '<?',
			timeHorizonInYears: '<?',
			includeTimeSelect: '@?',
			nested: '<?',
			fullWidth: '<?'
		},
		controller: [
		'APP_BASE_PATH',
		'DEFAULT_TIME_HORIZON_OPTIONS',
		'futureEarningsFactory',
		'planFactory', 
		HypotheticalPerformanceFunction],
		controllerAs: 'hypotheticalPerformance'
	};
	
	angular
		.module('hypotheticalPerformanceModule')
		.component('hypotheticalPerformance', hypotheticalPerformanceObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/hypothetical-performance/hypothetical-performance.html';
	}
	
	function HypotheticalPerformanceFunction(
		APP_BASE_PATH,
		DEFAULT_TIME_HORIZON_OPTIONS,
		futureEarningsFactory,
		planFactory
	){
		var hypotheticalPerformance = this;
		var baseURL = APP_BASE_PATH + '/start-investing/advanced-plans/';
		var detailPages = {
			'Balanced Investing' : baseURL + 'balanced-investing',
			'Long-Term Growth' : baseURL + 'long-term-growth',
			'Supplemental Income' :  baseURL + 'supplemental-income'
		};

		var havePlans = false;
		var shouldSetDefaults = true;

		function setDataForSelectedGoal(selectedGoal) {
			hypotheticalPerformance.dataForSelectedGoal = planFactory.getDataForSelectedGoal(hypotheticalPerformance.plans, selectedGoal);
			hypotheticalPerformance.planUrl = detailPages[selectedGoal];
			planFactory.trackGoalChanged(selectedGoal);
		}

		function getMaxMidpoint(plans) {
			var max = 0;

			angular.forEach(plans, function(plan) {
				max = Math.max(Number(plan.projectedQuarterlyReturnMidpoint), max);
			});

			return max;
		}

		hypotheticalPerformance.updateComponent = function() {
			hypotheticalPerformance.projectedAccountValue = futureEarningsFactory.getProjectedAccountValue(hypotheticalPerformance.amount,
				hypotheticalPerformance.dataForSelectedGoal.projectedQuarterlyReturnMidpoint,
				hypotheticalPerformance.timeHorizonInYears.value * 4);

			hypotheticalPerformance.maxHypotheticalReturnPerPeriod = getMaxMidpoint(hypotheticalPerformance.plans);
		};

		hypotheticalPerformance.$onChanges = function(changesObj) {
			if(shouldSetDefaults) {
				shouldSetDefaults = false;
				hypotheticalPerformance.appPath = APP_BASE_PATH;
				hypotheticalPerformance.selectedGoal = hypotheticalPerformance.selectedGoal || 'Balanced Investing';
				hypotheticalPerformance.amount = hypotheticalPerformance.amount || 10000;
				hypotheticalPerformance.timeHorizonOptions = angular.copy(DEFAULT_TIME_HORIZON_OPTIONS);
				hypotheticalPerformance.timeHorizonInYears = hypotheticalPerformance.timeHorizonInYears || hypotheticalPerformance.timeHorizonOptions[3];
			}

			if(angular.isDefined(changesObj.plans) && angular.isDefined(changesObj.plans.currentValue)) {
				havePlans = true;
			}

			if(havePlans) {
				setDataForSelectedGoal(hypotheticalPerformance.selectedGoal);
				hypotheticalPerformance.updateComponent();
			}
		};
	}
})(window.angular);